import { Controller } from '@hotwired/stimulus';
import { DotLottie } from '@lottiefiles/dotlottie-web';

export default class extends Controller {
    static values = {
        src: String,
    };

    connect () {
        this.player = new DotLottie({
            autoplay: true,
            loop: true,
            canvas: this.element,
            src: this.srcValue,
        });
    }
}
